import ContratosPjView from "../../components/rh/ContratosPjView";

export default function ContratosPjRh() {
  return <ContratosPjView />;
}
